module.exports = __webpack_public_path__ + "img/topics5.e7e429a4.jpg";